import { ArrowUpRight, Boxes, ClipboardCheck, Users } from "lucide-react";
import { Reveal } from "./Reveal";

const PRODUCTS = [
  {
    id: "stock",
    name: "TUPU Stock",
    descriptor: "Inventario · Pedidos · Abastecimiento",
    text: "Controla existencias, organiza pedidos y mantén tus locales abastecidos.",
    cta: "Conocer Stock",
    href: "https://stock.tupu.cl",
    color: "#22C55E",
    Icon: Boxes,
  },
  {
    id: "calidad",
    name: "TUPU Calidad",
    descriptor: "Controles · Registros · Evidencia · Cumplimiento",
    text: "Digitaliza controles, registra evidencia y mantén tu operación preparada para auditorías y fiscalizaciones.",
    cta: "Conocer Calidad",
    href: "https://calidad.tupu.cl",
    color: "#3B82F6",
    Icon: ClipboardCheck,
  },
  {
    id: "personas",
    name: "TUPU Personas",
    descriptor: "Asistencia · Turnos · Anticipos · Gestión",
    text: "Gestiona turnos, asistencia, anticipos y la operación diaria de tu equipo.",
    cta: "Conocer Personas",
    href: "https://personas.tupu.cl",
    color: "#F59E0B",
    Icon: Users,
  },
];

export const Products = () => (
  <section id="productos" data-testid="products-section" className="py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.22em] text-[#0F4D3F]/60" data-testid="products-eyebrow">
          Productos
        </p>
        <h2 className="max-w-2xl text-4xl font-medium tracking-tight text-[#1F3D35] md:text-5xl" data-testid="products-title">
          Una plataforma. Tres áreas clave de tu operación.
        </h2>
        <p className="mt-5 max-w-xl text-base font-light leading-relaxed text-[#1F3D35]/70 md:text-lg" data-testid="products-subtitle">
          Usa solo las herramientas que necesitas y suma nuevas soluciones a medida que tu operación crece.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
        {PRODUCTS.map(({ id, name, descriptor, text, cta, href, color, Icon }, i) => (
          <Reveal key={id} delay={i * 0.12}>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`product-card-${id}`}
              className="group flex h-full flex-col rounded-2xl border border-[#1F3D35]/8 bg-white p-8 shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_48px_rgba(15,77,63,0.10)]"
              style={{ ["--product"]: color }}
            >
              <span
                className="mb-7 flex h-14 w-14 items-center justify-center rounded-2xl transition-transform duration-300 group-hover:scale-105"
                style={{ backgroundColor: `${color}1A`, color }}
              >
                <Icon size={26} strokeWidth={1.8} />
              </span>
              <p className="text-[11px] font-bold uppercase tracking-[0.16em]" style={{ color }} data-testid={`product-descriptor-${id}`}>
                {descriptor}
              </p>
              <h3 className="mt-3 text-2xl font-semibold tracking-tight text-[#1F3D35] md:text-3xl">{name}</h3>
              <p className="mt-3 flex-1 text-sm font-light leading-relaxed text-[#1F3D35]/70 md:text-base">{text}</p>
              <span
                className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[#1F3D35]"
                data-testid={`product-cta-${id}`}
              >
                <span className="border-b-2 pb-0.5 transition-colors" style={{ borderColor: color }}>
                  {cta}
                </span>
                <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
